"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoValue = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../../../styles/context");
const wrapClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    pad: '0 6px',
    bdrad: '4px',
    trs: 'color .12s, background .12s, opacity .12s',
    whiteSpace: 'nowrap',
});
/**
 * Greyed-out clickable value display used in `def: true` (auto) mode by
 * defaultable args.
 */
const AutoValue = ({ onClick, children }) => {
    const styles = (0, context_1.useStyles)();
    const [hover, setHover] = React.useState(false);
    return (React.createElement("span", { className: wrapClass, style: hover
            ? { color: styles.g(0.05), background: styles.g(0, 0.06), opacity: 1 }
            : { color: styles.g(0.5), opacity: 0.75 }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), onClick: (e) => {
            e.stopPropagation();
            onClick();
        }, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }
        } }, children));
};
exports.AutoValue = AutoValue;
